import { Icon } from "assets/Icon";

interface InfoBoxProps {
	children?: React.ReactNode;
	className?: string;
}

export const InfoBox: React.FC<InfoBoxProps> = ({ children, className }) => {
	return (
		<div>
			<div className="relative top-3">
				<Icon
					icon="info2"
					iconClassName="fill-blue-300 stroke-white"
				></Icon>
			</div>
			<div
				className={`mx-2 rounded-md border-2 border-blue-200 p-3 ${className}`}
			>
				{children}
			</div>
		</div>
	);
};
